
import React, { FC } from 'react';
import { Box, Container, Grid, Skeleton } from '@mui/material';
import StyledBox from 'views/rebranded-module/OffRoadToursLandingViewV2/components/TestimonialsSection/TestimonialsSection.styles';

const TestimonialsSectionSkeleton: FC = () => {
  return (
    <StyledBox>
      <Box className="TSBackground">
        {/* Background Image Skeleton */}
        <Skeleton variant="rectangular" width="100%" height="100%" />
      </Box>
      <Box className="TSGradient" />
      <Container maxWidth="xl" className="TSContent">
        <Box className="RFASContent">
          {/* Overline Title Skeleton */}
          <Skeleton variant="text" width={200} height={20} sx={{ mb: 2 }} />
          
          {/* Main Title Skeleton */}
          <Skeleton variant="text" width={400} height={48} sx={{ mb: 6 }} />
          
          {/* Testimonials Grid */}
          <Grid container spacing={6}>
            {[...Array(3)].map((_, item) => (
              <Grid item lg={4} md={12} sm={12} key={item}>
                <Box className="TSBox">
                  {/* Testimonial Title Skeleton */}
                  <Skeleton variant="text" width="80%" height={24} sx={{ mb: 2 }} />
                  
                  {/* Comment Skeleton */}
                  <Box className="TSUserComment">
                    <Skeleton variant="text" width="100%" height={20} />
                    <Skeleton variant="text" width="95%" height={20} />
                    <Skeleton variant="text" width="90%" height={20} />
                    <Skeleton variant="text" width="70%" height={20} />
                  </Box>
                  
                  {/* Footer Section */}
                  <Box className="TSFooter" mt={2}>
                    <Box className="TSUserInfo">
                      {/* Avatar Skeleton */}
                      <Skeleton 
                        variant="circular" 
                        width={40} 
                        height={40} 
                        className="TSAvatar"
                      />
                      
                      {/* User Name Skeleton */}
                      <Skeleton 
                        variant="text" 
                        width={120} 
                        height={24} 
                        className="TSUserName"
                      />
                    </Box>
                    
                    {/* Quote Icon Skeleton */}
                    <Skeleton 
                      variant="rectangular" 
                      width={32} 
                      height={32} 
                      sx={{ borderRadius: 1 }} 
                      className="TSIcon"
                    />
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </StyledBox>
  );
};

export { TestimonialsSectionSkeleton };